import React, { useEffect, useState, Fragment } from 'react';
import { BookOpen, Trophy, Lock, Zap, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
const plans = [{
  id: 'pack',
  icon: BookOpen,
  name: 'ZURDO MASTER PACK',
  detail: '6 tomos + 6 bonos exclusivos',
  oldPrice: '$34.990',
  price: '$19.990',
  badge: null,
  save: null,
  checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51152409362665:1',
  extraBonos: []
}, {
  id: 'elite',
  icon: Trophy,
  name: 'PACK PRO ÉLITE',
  detail: '6 tomos + 6 bonos + 3 bonos Pro Élite exclusivos',
  oldPrice: '$43.990',
  price: '$27.990',
  badge: 'MÁS ELEGIDO',
  save: 'AHORRÁS $16.000',
  checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51152418537705:1',
  extraBonos: []
}];
export function Oferta() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);
  const [selected, setSelected] = useState('elite');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const timeBlocks = [{
    value: pad(h),
    label: 'HORAS'
  }, {
    value: pad(m),
    label: 'MIN'
  }, {
    value: pad(s),
    label: 'SEG'
  }];
  return <section id="oferta" className="py-16 bg-navy relative border-t border-white/5" data-id="element-176">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-celeste/5 blur-[120px] rounded-full pointer-events-none" data-id="element-177"></div>

      <div className="container mx-auto px-4 max-w-2xl relative z-10" data-id="element-178">
        <FadeIn data-id="element-179">
          {/* Countdown */}
          <div className="flex justify-center gap-3 mb-10" data-id="element-180">
            {timeBlocks.map((b, idx) => <Fragment key={b.label} data-id="element-181">
                <div className="bg-row1 border border-white/10 rounded-xl w-20 py-3 text-center" data-id="element-182">
                  <div className="font-display font-black text-3xl md:text-4xl text-white tabular-nums" data-id="element-183">
                    {b.value}
                  </div>
                  <div className="text-[10px] text-gray-400 tracking-widest mt-1 font-bold" data-id="element-184">
                    {b.label}
                  </div>
                </div>
                {idx < timeBlocks.length - 1 && <span className="font-display font-bold text-3xl text-celeste self-center" data-id="element-185">
                    :
                  </span>}
              </Fragment>)}
          </div>

          {/* Title */}
          <h2 className="font-display text-3xl md:text-4xl font-black text-center uppercase mb-2 text-white" data-id="element-186">
            Elegí tu <span className="text-celeste" data-id="element-187">acceso</span>
          </h2>
          <p className="text-center text-gray-300 mb-2" data-id="element-188">
            El precio de lanzamiento es por tiempo limitado.
          </p>
          <p className="text-center text-gray-400 text-sm mb-8" data-id="element-189">
            Ambas opciones incluyen los 6 bonos exclusivos completos
          </p>

          {/* Plans */}
          <div className="space-y-4 mb-8" data-id="element-190">
            {plans.map(plan => {
            const isActive = selected === plan.id;
            return <button key={plan.id} onClick={() => setSelected(plan.id)} aria-pressed={isActive} className={`w-full text-left rounded-2xl p-5 border-2 transition-all relative ${isActive ? 'border-gold bg-row1 shadow-[0_0_25px_rgba(201,168,76,0.15)]' : 'border-white/10 bg-row1/50 hover:border-white/25'}`} data-id="element-191">
                  <div className="flex items-start gap-4" data-id="element-192">
                    {/* Radio */}
                    <span className={`mt-1 w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isActive ? 'border-gold' : 'border-gray-500'}`} data-id="element-193">
                      {isActive && <span className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-194" />}
                    </span>

                    <div className="flex-1 min-w-0" data-id="element-195">
                      <div className="flex items-center gap-2 mb-1" data-id="element-196">
                        <plan.icon className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-gold' : 'text-celeste'}`} data-id="element-197" />
                        <span className="font-display font-black text-lg md:text-xl uppercase text-white" data-id="element-198">
                          {plan.name}
                        </span>
                      </div>

                      {(plan.badge || plan.save) && <div className="flex flex-wrap gap-2 mb-2" data-id="element-199">
                          {plan.badge && <span className="inline-flex items-center bg-gold text-navy text-[11px] font-black uppercase px-2 py-0.5 rounded" data-id="element-200">
                              {plan.badge}
                            </span>}
                          {plan.save && <span className="inline-flex items-center bg-green-500/20 text-green-400 text-[11px] font-bold uppercase px-2 py-0.5 rounded" data-id="element-201">
                              {plan.save}
                            </span>}
                        </div>}

                      <p className="text-gray-300 text-sm mb-3" data-id="element-202">
                        {plan.detail}
                      </p>

                      {/* Extra Bonos for Elite */}
                      {plan.extraBonos.length > 0 && <div className="mt-3 pt-3 border-t border-white/10 space-y-2" data-id="element-203">
                          {plan.extraBonos.map((bono, i) => <div key={i} className="flex items-start gap-2 text-green-400 text-xs font-medium" data-id="element-204">
                              <span className="bg-green-400/20 rounded-full p-0.5 flex-shrink-0 mt-0.5" data-id="element-205">
                                <ShieldCheck className="w-3 h-3 text-green-400" data-id="element-206" />
                              </span>
                              <span data-id="element-207">{bono}</span>
                            </div>)}
                        </div>}
                    </div>

                    {/* Price */}
                    <div className="text-right flex-shrink-0 ml-2" data-id="element-208">
                      <div className="text-gray-500 text-sm line-through" data-id="element-209">
                        {plan.oldPrice}
                      </div>
                      <div className={`font-display font-black text-2xl md:text-3xl ${isActive ? 'text-gold' : 'text-celeste'}`} data-id="element-210">
                        {plan.price}
                      </div>
                    </div>
                  </div>
                </button>;
          })}
          </div>

          {/* CTA */}
          <Button fullWidth className="py-5 text-lg md:text-xl" onClick={() => {
          const plan = plans.find(p => p.id === selected);
          if (plan?.checkoutUrl) {
            window.location.href = plan.checkoutUrl;
          }
        }} data-id="element-211">
            SÍ, QUIERO ACCEDER AHORA <ArrowRight className="w-6 h-6" data-id="element-212" />
          </Button>

          <p className="text-center text-gray-400 text-sm italic mt-4" data-id="element-213">
            La opción más elegida por zurdos que quieren resultados reales en la
            cancha
          </p>

          <div className="border-t border-white/10 mt-8 pt-6" data-id="element-214">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-gray-300" data-id="element-215">
              <span className="flex items-center gap-1.5" data-id="element-216">
                <Lock className="w-4 h-4 text-celeste" data-id="element-217" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218">
                <Zap className="w-4 h-4 text-celeste" data-id="element-219" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-220">
                <ShieldCheck className="w-4 h-4 text-celeste" data-id="element-221" /> Garantía 30
                días
              </span>
            </div>
            <div className="flex items-center justify-center gap-1.5 text-sm text-gray-400 mt-3" data-id="element-222">
              <CreditCard className="w-4 h-4 text-celeste" data-id="element-223" /> Mercado Pago ·
              Astro Pay
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}